exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".topline-section {\n  display: inline-block;\n  width: 22%;\n  font-size: 12;\n  border-right: 1px solid #ccc;\n  margin-right: 15px;\n  float: left; }\n  .topline-section .topline-metric-delta {\n    font-size: 12px;\n    color: #33a57b;\n    margin-left: 10px;\n    width: 55%;\n    font-weight: 100;\n    /*width:100px;*/\n    margin-top: 5px;\n    display: inline-block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/AnalyticsMetric/components/ToplineMetrics/ToplineSection/style.scss
// module id = 995
// module chunks = 0